export default "__VITE_ASSET__C$VWAva7__"